import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueI18n from 'vue-i18n';
import th from '@/locales/th';
import foodConfig from '@/config/foodConfig';
import hotelConfig from '@/config/hotelConfig';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ColorPicker, ColorPanel } from 'one-colorpicker';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(ColorPanel);
Vue.use(ColorPicker);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'th', // set locale
  messages: {
    th: {
      hello: 'hello world',
      ...th,
      ...foodConfig,
      ...hotelConfig,
    },
  },
  silentTranslationWarn: process.env.NODE_ENV === 'development',
});

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
